module.exports = __webpack_public_path__ + "img/web2_1.4fb51cdc.jpg";